class TimelineList {
	constructor () {
		this._dialog = Dialog.Modal(
			'available-timelines', _("Available Timelines"), LARGE, null, this._elem = UI.div()
		);
	}

	open() {
		this._elem.innerHTML = '';
		this._dialog.open(null, () => {
			document.dispatchEvent(new Event('primaryDataInvalid'));
		});

		API.fetch('timelines/available')
		.then(reply => {
			if (reply.timelines) reply.timelines.forEach(data => {
				this._elem.appendChild(
					TimelineListItem.fromArray(data).elem
				);
			})
		});
	}
}

class TimelineListItem {
	static fromArray(data, list) {
		let inst = new TimelineListItem(list);
		inst._id = data.shift();
		inst.name = data.shift();
		inst.selected = data.shift();
		return inst;
	}
	constructor(list) {
		this._list = list;
		this._id;

		this._elem = UI.listRow([
			UI.div('flex-1', this._name = UI.span()),
			UI.div('flex-0', [
				UI.label([
					UI.span(null, _("VISIBLE")),
					UI.styleChk(this._selected = UI.chk())
				]),
			])
		]);

		onEv(this._selected, 'change', this.save.bind(this));
	}
	get elem() { return this._elem; }
	set name(value) {
		this._name.innerText = value;
	}

	get selected() { return this._selected.checked; }
	set selected(value) {
		this._selected.checked = value !== null;
	}
	save() {
		API.update(
			`timelines/${this._id}`,
			{
				toggle: (this._selected.checked ? 1 : 0)
			}
		)
		.then(reply => {
			showError(reply);
		})
	}
}